import { useConfiguracionGlobal } from "./useCms";
import { site as fallbackSite } from "../data/site";

/**
 * Configuración del sitio: combina el single type `configuracion-global` del
 * CMS con el dataset estático de `data/site.ts`.
 *
 * Campo a campo: si el admin tiene el campo relleno en Strapi, se usa el
 * valor del CMS; si está vacío o el CMS aún no respondió, cae al valor
 * estático. Esto permite que el equipo cambie email, redes sociales y
 * tagline desde el admin sin redespliegue, manteniendo un fallback
 * razonable durante la primera carga o si la API falla.
 *
 * Si quieres añadir nuevos campos editables (ej. teléfono), añade el
 * campo al schema `configuracion-global` en Strapi, al type
 * `ConfiguracionGlobal` del frontend, y un nuevo `??` aquí.
 */
export function useSiteConfig() {
  const { data: cms } = useConfiguracionGlobal();

  return {
    // Nombre largo y short — el admin sólo gestiona el nombre del sitio.
    name: cms?.nombreSitio ?? fallbackSite.name,
    longName: fallbackSite.longName,
    tagline: cms?.tagline ?? fallbackSite.tagline,
    description: cms?.descripcionCorta ?? fallbackSite.description,

    // Contacto
    email: cms?.emailContacto ?? fallbackSite.email,

    // Datos institucionales sin equivalente en el CMS por ahora.
    university: fallbackSite.university,
    ages: fallbackSite.ages,

    // Moodle (solo en CMS — no hay fallback en site.ts).
    moodleUrl: cms?.moodleUrl,

    social: {
      facebook: {
        label: cms?.facebookHandle ?? fallbackSite.social.facebook.label,
        url: cms?.facebookUrl ?? fallbackSite.social.facebook.url,
      },
      instagram: {
        label: cms?.instagramHandle ?? fallbackSite.social.instagram.label,
        url: cms?.instagramUrl ?? fallbackSite.social.instagram.url,
      },
    },
  };
}
